import { jsxs as r } from "react/jsx-runtime";
import { J as s, $ as i } from "../../vendor-CPVnY93G.js";
import '../../assets/index25.css';const f = "_counter_1ijq0_1", m = {
  counter: f
}, l = ({ value: t, label: a, "aria-label": o, options: e }) => {
  const n = s(e).format(t), { visuallyHiddenProps: c } = i();
  return /* @__PURE__ */ r(
    "data",
    {
      value: t,
      className: m.counter,
      "aria-live": "polite",
      "aria-atomic": "true",
      "data-component": "Counter",
      children: [
        n,
        /* @__PURE__ */ r("span", { ...o ? c : void 0, children: [
          " ",
          a ?? o
        ] })
      ]
    }
  );
};
export {
  l as Counter
};
